import classes from './IconWrapper.module.scss';

// if you pass size prop, it will be same size across all device width
function IconWrapper({ children, size, color }) {
    return (
        <div
            style={{
                ...(size && { width: size, height: size, '--icon-width': `${(22/48) * size}px` }),
                ...(color && { backgroundColor: color }),
            }}
            className={classes.iconWrapper}
        >
            {children}
        </div>
    );
}
export default IconWrapper;
